module.exports = __webpack_public_path__ + "static/familyFull-deea83c81f2967400eb851bd0fa2d9fe.jpeg";